import dayjs from 'dayjs';
import { type DateRange } from '../types';

const isSameDay = (dateA?: Date | null, dateB?: Date | null) => {
  if (!dateA || !dateB) {
    return false;
  }

  return dayjs(dateA).isSame(dateB, 'day');
};

export const isSameRange = (range: DateRange | null, start: Date, end: Date) => {
  return isSameDay(range?.startDate, start) && isSameDay(range?.endDate, end);
};
